import React, {useEffect, useState} from "react";
import {SzButton, SzData, SzBox} from "@suezenv/react-theme-components";
import { useTranslationWithPrefix } from "../../../hooks/translation";
import { PCE_DETAIL_URL } from "../../../constants/redirectUrls";
import signalService from "../../../services/api/signal-service";
import { isEmptyArray } from "formik";

interface ISignalRelatedRequest {
    signalId: string;
}

const SignalRelatedRequest: React.FC<ISignalRelatedRequest> = ({signalId}) => {
    const trans = useTranslationWithPrefix("signalement", "detail_signal");
    const [elements, setElements] = useState<any>([])

    useEffect(() => {
        signalService.getRelatedElements(signalId)
        .then((response) => {
            setElements(response.data)
        })
    }, [signalId]);

    return isEmptyArray(elements) ? null : (
        <SzBox className='row bg-white p-3 mb-4'>
                {elements.map((element: any, key: string) => {
                    return <div className="row" key={key}>
                        <div className="col-6 mt-2 pl-5 d-flex justify-content-start">
                            <SzData>
                                <SzData.Title>{trans('related_element')}</SzData.Title>
                            </SzData>
                        </div>
                        <div className="col-6 d-flex justify-content-center">
                            <SzData>
                                <SzButton
                                    variant="secondary"
                                    onClick={() => {
                                        window.location.href = PCE_DETAIL_URL.replace(':requestId', element.leftRequest.id)
                                    }}
                                >
                                    {trans('access_to_request')}
                                </SzButton>
                            </SzData>
                        </div>
                    </div>
                })}
        </SzBox>
    );
}

export default SignalRelatedRequest;
